<template>
  <div>
    <div class="flight-school-details-container">
      <div class="cadets-table">
        <div class="cadets-table-header">
          <div
            class="grid px-3 gap-sm mb-3 align-items-center"
            :style="$global.dynamicColsV2(0.6, 1, 1, 1, 1, 1)"
          >
            <h2>All Cadets</h2>
            <HiloSelect
              v-for="(item, index) in filter.items"
              :key="index"
              :options="[]"
              v-model="filter[item.prop]"
              :placeholder="item.placeholder"
              theme="grey"
              :customStyle="{
                backgroundColor: '#e4e4e2',
                height: '35px',
              }"
            />
          </div>
        </div>
        <HiloTableV2 :columns="columns" :data="students" :hasDot="true" />
      </div>
    </div>

    <ToastNotifier ref="toast" />
  </div>
</template>
<script>
import dayjs from "dayjs";
import HiloSelect from "../../../components/HiloComponents/HiloSelect.vue";
import ToastNotifier from "../../../components/ToastNotifier.vue";
import ActiveStudentsAPIService from "../../../servicehandlers/ActiveStudentsAPIService.js";
import HiloTableV2 from "./HiloTableV2.vue";

const studentAPIService = new ActiveStudentsAPIService();
export default {
  name: "FlightSchoolDetails",
  components: { HiloTableV2, HiloSelect, ToastNotifier },
  props: ["id"],
  data() {
    return {
      school: null,
      tabs: ["All Students Cadets", "All Instructor Cadets"],
      activeTab: 0,
      subInfo: {
        left: "150 Student Cadets",
        right: "65 Instructor Cadets",
      },
      filter: {
        items: [
          { placeholder: "Grades", prop: "grade" },
          { placeholder: "Status", prop: "status" },
          { placeholder: "Hours", prop: "hours" },
          { placeholder: "All Schools", prop: "school" },
          { placeholder: "Program", prop: "program" },
        ],
      },
      columns: [
        { name: "Name", value: "name" },
        { name: "Grade", value: "grade", align: "center" },
        { name: "Status", value: "status" },
        { name: "Hr", value: "hr", align: "center" },
        { name: "Program", value: "program", align: "center" },
        { name: "Start", value: "start", align: "center" },
        { name: "End", value: "end", align: "center" },
        { name: "Balance", value: "balance", align: "center" },
        { name: "Link", value: "link", isUrl: true, align: "center" },
        { name: "Grade Book", value: "gradeBook", isUrl: true, align: "center" },
        { name: "Log Book", value: "logBook", isUrl: true, align: "center" },
      ],
      students: [],
    };
  },
  async mounted() {
    await this.getStudentDetails();
  },
  methods: {
    async getStudentDetails() {
      try {
        this.students = await studentAPIService.getAllStudentDetails(this.$router);

        for (let student of this.students) {
          if (student.details.class) {
            student.details.class.startDate = dayjs(student.details.class.startDate);
            student.details.class.endDate = dayjs(student.details.class.endDate);
          }
          student.user.image = getProcessedImageUrl(student.user.image);
          student.name = `${student.user.firstName} ${student.user.lastName}`;
        }
      } catch (error) {
        this.$refs.toast.showError("Unable to get student details");
      }
    },
  },
};
</script>
<style>
.flight-school-details-container {
  padding: 10px 35px;
  display: flex;
  flex-direction: column;
  gap: 60px;
}
.flight-school-details-tabs {
  display: flex;
  font-size: 14px;
}
.flight-school-details-tab {
  cursor: pointer;
  padding: 10px 20px;
  border-bottom: 2px solid #cfcfcf;
  color: #404040;
}
.flight-school-details-tab.active {
  border-bottom: 2px solid #3c78ff;
}
.cadets-table-header h2 {
  font-weight: bold;
  color: #404040;
  margin: unset;
}
.gap-sm {
  gap: 10px;
}
</style>
